export default __webpack_public_path__ + "static/blog-list-6f7f98e1501f993a7cf66a0056e20ae5.png";